import { BreadCrumb, Button, Title } from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip,
} from "@material-ui/core";
import UploadFilePage from "@upload/storage/pages/UploadFile";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useDwnloadCsvModel } from "../hooks/useDwnloadCsvModel";
import { Grid } from "@material-ui/core";
import { useSendFileCpftoJobBeneficiary } from "../hooks/useSendFileCpftoJobBeneficiary";
import { StatusBeneficiaryExternalApiEnum } from "../contracts";
import { TypeLoadCpfs } from "../enums/typeLoad";

export default function RegisterLoadCPF() {
  let { programCode }: { programCode: string } = useParams();
  const history = useHistory();

  const [displayFormFieldModal, setDisplayFormFieldModal] = useState(false);
  const [radioState, setRadioState] = useState(TypeLoadCpfs.PARTIAL);
  const [nameFileUpload, setNameFileUpload] = useState("");
  const [messageErroDownload, setMessageErroDownload] = useState("");

  const { mutateAsync } = useDwnloadCsvModel();
  const mutationSendFile = useSendFileCpftoJobBeneficiary();

  const downloadCsvModel = async () => {
    try {
      const { url } = await mutateAsync({
        input: { programID: programCode },
      });

      if (url) {
        const link = document.createElement("a");
        link.download = url;
        link.href = url;
        link.click();
      }
    } catch (err) {
      console.error(err);
      setMessageErroDownload(
        "Erro ao efetuar o download, por favor tente mais tarde"
      );
    }
  };

  const openModal = () => {
    setDisplayFormFieldModal(true);
  };

  const partial = () => {
    setRadioState(TypeLoadCpfs.PARTIAL);
  };
  const full = () => {
    setRadioState(TypeLoadCpfs.FULL);
  };

  const closeModal = () => {
    setDisplayFormFieldModal(false);
  };

  const nameFileUploadModal = (name: string) => {
    setNameFileUpload(name);
  };

  const confirmLoadCpfs = async () => {
    try {
      const result = await mutationSendFile.mutateAsync({
        input: {
          fileName: nameFileUpload,
          programID: programCode,
          status: StatusBeneficiaryExternalApiEnum.ACTIVE,
          typeLoad: radioState,
        },
      });

      history.push(
        `/pbm/programs/${programCode}/loadcpf/confirm/${result.processed}`
      );
    } catch (error) {
      console.log(error);
    }
  };
  const FastEditionTooltip = {
    fontSize: "16px",
    maxWidth: 500,
  };
  return (
    <>
      <div className="flex items-center w-full">
        <div className="flex-1">
          <Title marginBottom={0}>CPFs</Title>
        </div>

        <div className="flex-shrink-0 space-x-2">
          <Restricted to="loadCpf.programs">
            {!messageErroDownload ? (
              <>
                <Button
                  variant="text"
                  color="primary"
                  onClick={downloadCsvModel}
                >
                  Baixar planilha modelo
                </Button>
              </>
            ) : (
              <>
                <b>{messageErroDownload}</b>
              </>
            )}
          </Restricted>

          <Restricted to="loadCpf.programs">
            <Button onClick={openModal} color="primary">
              Carregar CPFs
            </Button>
          </Restricted>
        </div>
      </div>

      <BreadCrumb
        items={[
          { path: "/pbm/programs", label: "Programas" },
          {
            path: `/pbm/programs/${programCode}`,
            label: programCode,
          },
          { label: "CPFs" },
        ]}
      />

      <Dialog
        fullWidth
        open={displayFormFieldModal}
        onClose={() => setDisplayFormFieldModal(false)}
      >
        <DialogTitle>
          <div className="flex flex-row justify-between">
            <h1 className="mt-1 text-3xl font-bold text-gray-600">
              Upload de Arquivo
            </h1>
            <div>
              <IconButton aria-label="close" onClick={closeModal}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <UploadFilePage
            closeModal={closeModal}
            nameFileUploadModal={nameFileUploadModal}
          />
        </DialogContent>
        <DialogActions>&nbsp;</DialogActions>
      </Dialog>

      <Grid container>
        <Grid item>
          <div className="flex flex-row">
            <h6 className="mb-4 mr-4 font-medium text-gray-500 text-md">
              Tipo de Carga:
            </h6>
            <RadioGroup
              className="flex flex-col text-gray-500 "
              defaultValue="partial"
              name="radio-buttons-group"
            >
              <Grid item>
                <FormControlLabel
                  value="partial"
                  control={<Radio />}
                  label="Incrimental"
                  onClick={partial}
                />
                <Tooltip
                  title={
                    <span style={FastEditionTooltip}>
                      Selecionando está opção, o sistema irá acrescentar os
                      CPF's informados no arquivo a base do programa.
                    </span>
                  }
                  placement="right"
                >
                  <InfoOutlinedIcon fontSize="small" />
                </Tooltip>
              </Grid>
              <Grid item>
                <FormControlLabel
                  value="full"
                  control={<Radio />}
                  label="Sobreposição"
                  onClick={full}
                />
                <Tooltip
                  title={
                    <span style={FastEditionTooltip}>
                      Selecionando está opção, o sistema irá desativar todos os
                      CPF's cadastrados e manterá ativo apenas os contidos no
                      arquivo.
                    </span>
                  }
                  placement="right"
                >
                  <InfoOutlinedIcon fontSize="small" />
                </Tooltip>
              </Grid>
            </RadioGroup>
          </div>

          <h6 className="mb-4 font-medium text-gray-500 text-md">
            Passo a passo para carga de CPFs
          </h6>

          <ol className="px-1 py-1 text-sm text-gray-500 list-decimal list-inside whitespace-nowrap">
            <li>Baixe à planilha modelo</li>
            <ul className="ml-3.5">
              <li>Preencha os dados</li>
              <li>
                O campo <b>customerCode</b> é o CPF
              </li>
            </ul>
            <li>Faça upload do CSV</li>
            <li>Confirmar carga</li>
          </ol>
        </Grid>
      </Grid>

      <div className="flex justify-end">
        <Button
          color="primary"
          onClick={confirmLoadCpfs}
          disabled={!nameFileUpload}
        >
          Confirmar carga
        </Button>
      </div>
    </>
  );
}
